(function(angular, module) {var getPrincipalProgram, getProgramIssues, getProgramPermissions, indexController, indexHeaderView, indexListView, menuView, stateConfig;

indexController = function(ChangeLogService, changes, program) {
  'ngInject';
  var vm;
  vm = this;
  this.program = program;
  this.changes = changes;
  this.hasMore = changes.length > 0;
  this.loadMore = function() {
    var lastId;
    lastId = vm.changes[changes.length - 1].id;
    return ChangeLogService.index({
      after: lastId,
      count: 1
    }).then(function(moreChanges) {
      var ref;
      vm.hasMore = moreChanges.length > 0;
      (ref = vm.changes).push.apply(ref, moreChanges);
    });
  };
};

indexListView = {
  templateUrl: 'changeLog/list',
  controller: indexController,
  controllerAs: 'ctrl',
  resolve: {
    changes: function(ChangeLogService, Principal) {
      'ngInject';
      Principal.new_announcements = false;
      return ChangeLogService.index({
        count: 3
      });
    }
  }
};

indexHeaderView = {
  template: '<a if-permission="createChangeLog" class="button" ui-sref="^.new">New Post</a>'
};

menuView = {
  templateUrl: 'programs/menu',
  controller: 'ProgramBaseController'
};

getPrincipalProgram = function(Principal, ModelService) {
  'ngInject';
  if (Principal.program_count === 1) {
    return ModelService.getRelation('program', Principal.program_slug, 'summary');
  } else {
    return null;
  }
};

getProgramPermissions = function(program, ModelService) {
  'ngInject';
  if (program != null) {
    return ModelService.getModelRelation(program, 'permissions');
  } else {
    return {};
  }
};

getProgramIssues = function(program, IssueService) {
  'ngInject';
  if (program != null) {
    return IssueService.loadIssues('program', program.id);
  }
  return {};
};

stateConfig = function($stateProvider) {
  'ngInject';
  $stateProvider.state('changeLog', {
    abstract: true,
    parent: 'basic',
    url: '/announcements',
    resolve: {
      program: getPrincipalProgram,
      permissions: getProgramPermissions,
      issues: getProgramIssues
    },
    views: {
      '': {
        templateUrl: 'changeLog/base'
      },
      'contextNav@basic': menuView
    }
  });
  return $stateProvider.state('changeLog.list', {
    url: '',
    views: {
      'header': indexHeaderView,
      '@changeLog': indexListView
    }
  });
};

module.config(stateConfig);
})(angular, angular.module("changeLog"));